import { render, staticRenderFns } from "./BankRunBenchmarkingBlock.vue?vue&type=template&id=121786b4&scoped=true"
import script from "./BankRunBenchmarkingBlock.vue?vue&type=script&lang=js"
export * from "./BankRunBenchmarkingBlock.vue?vue&type=script&lang=js"
import style0 from "./BankRunBenchmarkingBlock.vue?vue&type=style&index=0&id=121786b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121786b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
